module.exports = __webpack_public_path__ + "static/img/preview-2.e11995d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/preview/preview-2.png
// module id = Cren
// module chunks = 35